export const STOREFRONT_TEMPLATES = Object.freeze({
    CLASSIC: 'classic',
    SHOWCASE: 'showcase',
    BOUTIQUE: 'boutique'
});

export const normalizeStorefrontTemplate = (value) => {
    if (value === STOREFRONT_TEMPLATES.SHOWCASE) {
        return STOREFRONT_TEMPLATES.SHOWCASE;
    }

    if (value === STOREFRONT_TEMPLATES.BOUTIQUE) {
        return STOREFRONT_TEMPLATES.BOUTIQUE;
    }

    return STOREFRONT_TEMPLATES.CLASSIC;
};

export const storefrontTemplateClassName = (value) => (
    `storefront-template-${normalizeStorefrontTemplate(value)}`
);
